import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import './MayorgaSection.css';
import parse from "html-react-parser";

const InterviewBanner = ({ webpageData }) => {
  const interviewBannerData = webpageData?.interviewBannerData || {};
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";

  return (
    <div className="interview-banner-mayorga">
      <div className="mayorga-bg">
      <div className="play-button-overlay-he">
      <a
    href="https://youtu.be/owiYnt6_6h4"
    target="_blank"
    rel="noopener noreferrer"
  >
  <img
    src={imgCDNURL + "play-button-icon.webp"}
    alt="Play"
    className="play-button-icon-he"
  />
  </a>
</div>
        <Container>
          <Row className="align-items-center">
            

            <Col lg={6} className="image-section-column">
              <div className="image-section">
                <div className="personmayorga-card">
                  <div className="personmayorga-image">
                  <img
                      src={imgCDNURL + "Pavan-Agarwal.webp"}
                      alt="Pavan Agarwal"
                      className="img-fluid pavanimagechangesdesktop"
                    />
                    <img
                      src={imgCDNURL + "Milena-Mayorga.webp"}
                      alt="H.E. Milena Mayorga"
                      className="img-fluid"
                    />

                    
                  </div>
                </div>
              </div>


              <div className="personpavanhe-info-desktop">
                <div className="pavannamechangeshe-info">
                  <h3 className="pavannamechangeshe-name "><a className="custom-link" href="https://www.swmc.com/pavan" rel='noreferrer noopener' target='_blank'>Pavan Agarwal</a></h3>
                  <p className="pavannamechangeshe-title custom-link">CEO of <a  href="https://www.swmc.com/" rel='noreferrer noopener' target='_blank'>Sun West</a> and Creator of <a href="https://www.swmc.com/angelai" rel='noreferrer noopener' target='_blank'>AngelAi</a></p>
                </div>
              </div>
            </Col>


            <Col lg={6}>
              <div className="content-section-mayorga">
                <h1 className="banner-title-mayorga">

                  {/* <span className="highlight">{parse(interviewBannerData.interviewHighlight || "")} </span><br />{parse(interviewBannerData.interviewTitle || "")} <br />{parse(interviewBannerData.interviewHighlight || "")} */}

                  <span className="highlight">Forging Global Partnerships </span><br />{parse(interviewBannerData.interviewTitle || "")} <br />H.E. Milena Mayorga
                </h1>
                <p className="banner-description-he">
                  {/* {parse(interviewBannerData.interviewDescription || "")} */}

                  In an exclusive interview, H.E. Milena Mayorga, Ambassador of El Salvador, shared her country’s groundbreaking journey in embracing Bitcoin and its potential to drive financial inclusion. Ambassador Mayorga discusses El Salvador's pioneering role in the global cryptocurrency landscape and highlights the importance of digital currencies in empowering underserved communities. This insightful conversation sheds light on the power of innovative policies in positioning a nation at the forefront of digital finance. </p>
              </div>



              <div className="personmayorga-info-desktop">
                <div className="personmayorga-info">
                  <h3 className="personmayorga-name">H.E. Milena Mayorga</h3>
                  <p className="personmayorga-title">Ambassador of El Salvador</p>

                </div>
              </div>





            </Col>
          </Row>
        </Container>


        
        <div className="speaker-card-mobile-he">
          <img
            src={imgCDNURL + "Milena-Mayorga-mobile.webp"}
            alt="H.E. Milena Mayorga"
            className="speaker-image-mobile-he"
            loading="lazy"
          />
          <div className="speaker-info-strip">
            <h3 className="speaker-name-mobile">H.E. Milena Mayorga</h3>
            <p className="speaker-title-mobile">Ambassador of El Salvador</p>
          </div>
        </div>

        <div className="speaker-card-mobile mt-5">
          <img
            src={imgCDNURL + "Pavan-Agarwal-mobile.webp"}
            alt="Pavan Agarwal"
            className="speaker-image-mobilepavan"
            loading="lazy"
          />
          <div className="speaker-info-strip">
            <h3 className="speaker-name-mobile"><a className="custom-link" href="https://www.swmc.com/pavan" rel='noreferrer noopener' target='_blank'>Pavan Agarwal</a></h3>
            <p className="speaker-title-mobile custom-link">CEO of <a href="https://www.swmc.com/" rel='noreferrer noopener' target='_blank'>Sun West</a> and <br/>Creator of <a href="https://www.swmc.com/angelai" rel='noreferrer noopener' target='_blank'>AngelAi</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewBanner;
